import React from 'react';
import ContentContainer from 'templates/content-container/contentContainer';
import ContentContainerToolbar from 'ui-components/molecules/content-container-toolbar/contentContainerToolbar';
import Table from 'ui-components/table/table';
import { getWeeks } from './getWeeks';
import { useHistory } from 'react-router-dom';
import Button, { ButtonSizes, ButtonThemes } from 'ui-components/button/button';
import TargetWeek from './sidebars/targetWeek';
import UpdateWeek from './sidebars/updateWeek';
import { useDeleteWeek, useWeeks } from './hooks/useWeek';
import './cloneWeek.scss';

const CloneWeek: React.FC = () => {
  const history = useHistory();

  const [selectedWeek, setSelectedWeek] = React.useState<string>("");
  const [division, setDivision] = React.useState<string>("");
  const [modalOpen, setModalOpen] = React.useState<boolean>(false);
  const [updateWeekModalOpen, setUpdateWeekModalOpen] = React.useState<boolean>(false);
  const [isEdit, setIsEdit] = React.useState<boolean>(false);
  const [editWeek, setEditWeek] = React.useState<{
    weekStartDate: string;
    division: string;
    weekDescription: string;
    scheduleType: string;
    status: string;
    dispatches?: number;
    createdAt?: string;
    lastModifiedAt?: string;
  } | null>(null);

  const { data: weekOptionsData, isLoading: isLoadingWeeks, refetch } = useWeeks();
  const deleteWeekMutation = useDeleteWeek(() => refetch());

  const handleOpen = (weekStartDate: string) => {
    history.push(`/static-load?weekStartDate=${weekStartDate}`);
  };

  const handleClone = (weekStartDate: string, division: string) => {
    setSelectedWeek(weekStartDate);
    setDivision(division);
    setModalOpen(true);
  };

  const handleEdit = (
    weekStartDate: string,
    division: string,
    weekDescription: string,
    scheduleType: string,
    status: string,
    dispatches?: number,
    createdAt?: string,
    lastModifiedAt?: string,
  ) => {
    setUpdateWeekModalOpen(true);
    setIsEdit(true);
    setEditWeek({
      weekStartDate,
      division,
      weekDescription,
      scheduleType,
      status,
      dispatches,
      createdAt,
      lastModifiedAt,
    });
  };

  const handleDelete = (weekStartDate: string, division: string) => {
    deleteWeekMutation.mutate({
      division,
      weekStartDate,
    });
  }

  return <ContentContainer mods={{ "full-width": true }}
    titleComponent={
      <div className='clone-week-container-toolbar'>
        <ContentContainerToolbar
          title="Manage Schedules">
        </ContentContainerToolbar>
      </div>
    }
  >
    <div className='clone-week-container-toolbar-buttons'>
      <Button theme={ButtonThemes.grayInverted}
        size={ButtonSizes.auto}
        onClick={() => history.push('/static-load')}> ← Back to Schedule </Button>
      <Button theme={ButtonThemes.blue}
        size={ButtonSizes.auto}
        onClick={() => {
          setIsEdit(false);
          setUpdateWeekModalOpen(true);
        }}> + Create New Schedule</Button>
    </div>
    <div className='clone-week-container'>
      <Table
        data={weekOptionsData ?? []}
        columns={getWeeks(handleOpen, handleClone, handleEdit, handleDelete)}
        isLoading={isLoadingWeeks}
        infiniteScroll={true}
      />
    </div>
    <TargetWeek
      isOpen={modalOpen}
      onClose={() => setModalOpen(false)}
      weekStartDate={selectedWeek}
      division={division}
      onCloneSuccess={refetch}
    />
    <UpdateWeek
      isOpen={updateWeekModalOpen}
      onClose={() => setUpdateWeekModalOpen(false)}
      isLoading={false}
      refetchGetWeeks={refetch}
      isEdit={isEdit}
      editWeek={editWeek ?? { weekStartDate: "", division: "", weekDescription: "", scheduleType: "", status: "" }} />
  </ContentContainer>
};

export default CloneWeek;
